import * as React from "react";
import { useEffect, useRef } from "react";
import { useRoomSettings } from "../context";
import { Box, Slide } from "@mui/material";
import Participants from "./participants/Container";
import { SidebarState } from "../types";
import ChatContainer from "./chat/Container";
import SelfVideoPanel from "../self-video/SelfVideoPanel";
import { useSettings } from "../../tools";
import { sidebarWidth } from "../tools";
import { useSelfVideoDialogSettings } from "../self-video/context";

const Renderer = () => {
    const roomSettings = useRoomSettings();
    // prevStateRef is used for show the content meanwhile the sidebar is sliding out
    const prevStateRef = useRef<SidebarState>(null);

    useEffect(() => {
        prevStateRef.current = roomSettings.sidebarState;
    });

    if (
        roomSettings.sidebarState === "chat" ||
        (prevStateRef.current === "chat" && roomSettings.sidebarState === "hidden")
    )
        return <ChatContainer />;

    if (
        roomSettings.sidebarState === "participant" ||
        (prevStateRef.current === "participant" && roomSettings.sidebarState === "hidden")
    )
        return <Participants />;

    return null;
};

const SidebarContainer = ({ style }: { style?: React.CSSProperties }) => {
    const roomSettings = useRoomSettings();
    const settings = useSettings();
    const { alwaysFloat } = useSelfVideoDialogSettings();

    return (
        <Slide direction="left" in={roomSettings.sidebarState !== "hidden"} mountOnEnter unmountOnExit>
            <Box
                sx={(theme) => ({
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    backgroundColor: theme.palette.background.default,
                    borderTop: `1px solid ${theme.palette.divider}`,
                    justifyContent: "space-between",
                    width: sidebarWidth,
                    flexShrink: 0,
                    ...style,
                })}
            >
                <>
                    <Renderer />
                    {settings.video && !alwaysFloat && <SelfVideoPanel />}
                </>
            </Box>
        </Slide>
    );
};

export default SidebarContainer;
